import {ModulePaqueteria} from "@/model/Module/ModulePaqueteria";
import {ModuleMix} from "@/model/Module/ModuleMix";
import {ModuleMixAlt} from "@/model/Module/ModuleMixAlt";
import {ModuleTintoreria} from "@/model/Module/ModuleTintoreria";
import {ModuleTintoreriaOld} from "@/model/Module/ModuleTintoreriaOld";
import {ModuleMaster} from "@/model/Module/ModuleMaster";
import {ModuleMasterOnPaqueteria} from "@/model/Module/ModuleMasterOnPaqueteria";
import {ModuleZMaster4A} from "@/model/Module/ModuleZMaster4A";
import {ModuleZMaster4B} from "@/model/Module/ModuleZMaster4B";
import {ModuleZMaster4C} from "@/model/Module/ModuleZMaster4C";
import {ModuleZPaqueteriaA} from "@/model/Module/ModuleZPaqueteriaA";
import {ModuleZPaqueteriaB} from "@/model/Module/ModuleZPaqueteriaB";
import {ModuleZPaqueteriaC} from "@/model/Module/ModuleZPaqueteriaC";
import {ModuleZMixA} from "@/model/Module/ModuleZMixA";
import {ModuleZMixB} from "@/model/Module/ModuleZMixB";
import {ModuleZMixC} from "@/model/Module/ModuleZMixC";
import {ModuleZ5CompB} from "@/model/Module/ModuleZ5CompB";
import {ModuleScreenOnly} from "@/model/Module/ModuleScreenOnly";
import {IAbstractCell, ICell} from "@/model/Locker/lockerInterfaces";
import {IAbstractModule, IModule, IModuleDirection, IModuleType} from "@/model/Locker/IModule";
import {ModuleZ5compA} from "@/model/Module/ModuleZ5compA";
import {ModuleZ6compA} from "@/model/Module/ModuleZ6compA";
import {ModuleZ8compA} from "@/model/Module/ModuleZ8compA";
import {ModuleZ11compA} from "@/model/Module/ModuleZ11compA";
import {ModuleZMaster3A} from "@/model/Module/ModuleZMaster3A";
import {ModuleZ7compA} from "@/model/Module/ModuleZ7compA";
import {ModuleZ4compA} from "@/model/Module/ModuleZ4compA";
import {ModuleZ7compB} from "@/model/Module/ModuleZ7compB";
import {ModuleZMaster2A} from "@/model/Module/ModuleZMaster2A";
import {ModuleZ2compA} from "@/model/Module/ModuleZ2compA";
import {ModuleZ3compA} from "@/model/Module/ModuleZ3compA";
import {ModuleZ8compB} from "@/model/Module/ModuleZ8compB";
import {ModuleZ8compC} from "@/model/Module/ModuleZ8compC";
import {ModuleZ9compA} from "@/model/Module/ModuleZ9compA";
import {ModuleZ10compA} from "@/model/Module/ModuleZ10compA";
import {ModuleZ4compB} from "@/model/Module/ModuleZ4compB";
import {ModuleZMaster4E} from "@/model/Module/ModuleZMaster4E";
import {ModuleZ9compB} from "@/model/Module/ModuleZ9compB";
import {ModuleZ10compB} from "@/model/Module/ModuleZ10compB";
import {ModuleZ10CompWithXLA} from "@/model/Module/ModuleZ10CompWithXLA";
import {ModuleZ9compXL} from "@/model/Module/ModuleZ9compXL";
import {ModuleZMaster7} from "@/model/Module/ModuleZMaster7";
import {ModuleZ4compC} from "@/model/Module/ModuleZ4compC";
import {ModuleZ5CompC} from "@/model/Module/ModuleZ5CompC";
import {ModuleZ7CompC} from "@/model/Module/ModuleZ7CompC";
import {ModuleZ11CompB} from "@/model/Module/ModuleZ11CompB";
import {ModuleZ10compC} from "@/model/Module/ModuleZ10CompC";
import {ModuleZ6compB} from "@/model/Module/ModuleZ6compB";
import {ModuleZ9compXLB} from "@/model/Module/ModuleZ9compXLB";
import {ModuleZ5CompD} from "@/model/Module/ModuleZ5CompD";
import {ModuleZ6compC} from "@/model/Module/ModuleZ6compC";
import {ModuleZ6compD} from "@/model/Module/ModuleZ6compD";
import {ModuleZ10CompWithXLB} from "@/model/Module/ModuleZ10CompWithXLB";
import {ModuleZMix16} from "@/model/Module/ModuleZMix16";
import {ModuleZMix14} from "@/model/Module/ModuleZMix14";
import {ModuleZMix10} from "@/model/Module/ModuleZMix10";
import {ModuleZMix10D} from "@/model/Module/ModuleZMix10D";
import {ModuleZMix12D} from "@/model/Module/ModuleZMix12D";
import {ModuleZMix15D} from "@/model/Module/ModuleZMix15D";
import {ModuleZ5compE} from "@/model/Module/ModuleZ5compE";
import {ModuleZ4mixA} from "@/model/Module/ModuleZ4mixA";
import {ModuleZ3compB} from "@/model/Module/ModuleZ3compB";
import {ModuleZ9compC} from "@/model/Module/ModuleZ9compC";

/**
 * to add a new column type:
 * - create the definition (eg. model/Module/ModuleZ2compA.ts)
 *   - set type (use new type except special cases)
 *   - change name
 *   - set cell sizes
 *   - set accessible ones
 * - add here in moduleDefs - NOTE order matters
 * - add here in moduleDefsUIOrdered - NOTE order matters
 * - IF new type (normally use a new type, ONLY columns with same cells should have the same type, when only connectors differ)
 *   - add to IModule.ts
 *   - add to translations lockers.locker.module_name.x
 */
export class CellStructureBuilder {

  // order f-ing matters!!! modules with more connectors should come first to avoid conflicts
  // also note that variants are in reverse order as we show them in reverse (this doesn't apply any more as we have the
  //  moduleDefsUIOrdered duplicate which takes care of nice ordering
  public static readonly moduleDefs = [
    ModuleZMix16,
    ModuleZMix14,
    ModuleZMix10,
    ModuleZMix10D, // 28
    ModuleZMix12D, // 30
    ModuleZMix15D, // 29
    ModulePaqueteria, // 18
    ModuleMix, // 12
    ModuleMixAlt, // 12
    ModuleZ11compA,
    ModuleZ11CompB,
    ModuleZ10compC,
    ModuleZ10CompWithXLB,
    ModuleZ10CompWithXLA,
    ModuleZ10compB,
    ModuleZ10compA,
    // we have A-B-C variants with the same type because connectors differ (old types)
    ModuleZPaqueteriaC, // 10
    ModuleZPaqueteriaB, // 10
    ModuleZPaqueteriaA, // 10
    ModuleZ9compB,
    ModuleZ9compA,
    ModuleZ9compC,
    ModuleZMixC, // 8
    ModuleZMixB, // 8
    ModuleZMixA, // 8
    ModuleZ8compC,
    ModuleZ8compB,
    ModuleZ8compA,
    ModuleZ7compB,
    ModuleZ7compA,
    ModuleZ7CompC,
    ModuleTintoreria, // 6
    ModuleZ6compA,
    ModuleZ6compB,
    ModuleZ6compC,
    ModuleZ6compD,
    ModuleZ5compA,
    ModuleZ5CompB,
    ModuleZ5CompC,
    ModuleZ5CompD,
    ModuleZ5compE,
    ModuleZ4compC,
    ModuleZMaster4E,
    ModuleZMaster4C,
    ModuleZMaster4B,
    ModuleZMaster4A,
    ModuleZ4compB,
    ModuleZ4compA,
    ModuleZ4mixA,
    ModuleTintoreriaOld, // 4
    ModuleMaster, // 3
    ModuleMasterOnPaqueteria, // 3
    ModuleScreenOnly, // 3
    ModuleZ3compA,
    ModuleZ3compB,
    ModuleZMaster3A,
    ModuleZ2compA,
    ModuleZMaster2A,
    ModuleZ9compXLB,
    ModuleZ9compXL,
    ModuleZ11compA,
    ModuleZMaster7,
    ModuleScreenOnly,
  ];

  public static readonly moduleDefsUIOrdered = [
    ModuleZ2compA,
    ModuleZ3compA,
    ModuleZ3compB,
    ModuleZ4compA,
    ModuleZ4compC,
    ModuleZ4mixA,
    ModuleZ5compA,
    ModuleZ5CompB,
    ModuleZ5CompC,
    ModuleZ5CompD,
    ModuleZ5compE,
    ModuleZ6compA,
    ModuleZ6compB,
    ModuleZ6compC,
    ModuleZ6compD,
    ModuleZ7compA,
    ModuleZ7compB,
    ModuleZ7CompC,
    ModuleZ8compA,
    ModuleZMix16,
    ModuleZMix14,
    ModuleZMix10,
    ModuleZMix10D,
    ModuleZMix12D,
    ModuleZMix15D,
    ModuleZ8compB,
    ModuleZ8compC,
    ModuleZ9compA,
    ModuleZ9compB,
    ModuleZ9compC,
    ModuleZ9compXL,
    ModuleZ9compXLB,
    ModuleZ10compA,
    ModuleZ10compB,
    ModuleZ10compC,
    ModuleZ10CompWithXLA,
    ModuleZ10CompWithXLB,
    ModuleZ11compA,
    ModuleZ11CompB,
    ModuleZMaster2A,
    ModuleZMaster3A,
    ModuleZMaster4A,
    ModuleZ4compB,
    ModuleZMaster7,
    ModuleZMixA, // 8
    ModuleZPaqueteriaA, // 10

    ModuleScreenOnly, // 3

    ModuleZMaster4B,
    ModuleZMaster4C,
    ModuleZMaster4E,
    ModuleZMixB, // 8
    ModuleZMixC, // 8
    ModuleZPaqueteriaB, // 10
    ModuleZPaqueteriaC, // 10

    ModuleMix, // 12
    ModuleMixAlt, // 12
    ModuleMaster, // 3
    ModuleMasterOnPaqueteria, // 3
    ModulePaqueteria, // 18
    ModuleTintoreria, // 6
    ModuleTintoreriaOld, // 4
  ];

  private readonly LOCKER_ID_LAGOON = 21;

  public fromCells(cells: ICell[], lockerId: number): IModule[] {

    // I won't process lagoon cells
    if (lockerId == this.LOCKER_ID_LAGOON) {
      return [this.makeCrappyModule(cells)];
    }

    let ret: IModule[] = [];
    let remainingCells = cells;
    while (remainingCells.length) {
      let block = remainingCells[0].block;
      let blockCells = remainingCells.filter(each => each.block === block);
      remainingCells = remainingCells.filter(each => each.block !== block);
      // console.log('blockCells', blockCells, remainingCells);
      while (blockCells.length) {
        let module: IModule | null = null;
        try {
          let moduleCells = this.pickCellsForAModule(blockCells, true);
          if (moduleCells.length > 0) {
            blockCells = blockCells.filter(cell => moduleCells.indexOf(cell) === -1);
            module = this.makeModuleFromCells(moduleCells);
            // console.log('moduleCells', moduleCells, blockCells, module);
          }
        } catch (e) {
          let moduleCells = blockCells;
          blockCells = [];
          module = this.makeCrappyModule(moduleCells);
          // console.log('moduleCellsCrappy', moduleCells, blockCells, module);
        }
        if (module) {
          ret.push(module);
        }
      }
    }
    const hasScreen = !!ret.find(each => each.hasScreen);
    if (!hasScreen && !!ret.length) {
      ret.unshift(this.makeScreenOnlyModule());
    }
    return this.orderModules(ret);
  }

  private makeCrappyModule(cells: ICell[]): IModule {
    let ret: IModule = {
      type: IModuleType.crap,
      block: cells[0].block,
      direction: cells[0].direction,
      hasScreen: false,
      blocked_column: !!cells[0].blocked_column,
      column_order: cells[0].column_order || 0,
      columns: [cells],
    };
    return ret;
  }

  private makeScreenOnlyModule(): IModule {
    return {
      type: IModuleType.screenOnly,
      block: -1,
      direction: IModuleDirection.left,
      hasScreen: true,
      blocked_column: false,
      column_order: 0,
      columns: [],
    };
  }

  private pickCellsForAModule(blockCells: ICell[], allowLose: boolean): ICell[] {
    // first, try to match modules exactly by connector and cell size
    for (let i = 0; i < CellStructureBuilder.moduleDefs.length; i++) {
      if (this.cellsContainModule(blockCells, CellStructureBuilder.moduleDefs[i], true)) {
        const moduleCells = this.flatModuleCells(CellStructureBuilder.moduleDefs[i]);
        const moduleConnectors = moduleCells.map(eachCell => eachCell.connector);
        const ret = blockCells.filter(eachCell => moduleConnectors.indexOf(eachCell.connector) !== -1)
        // console.log('moduleCellsXXX', moduleDef, moduleConnectors, ret);
        return ret;
      }
    }
    // if no strict match found, try lose check by just connector
    //  necessary ATM as some cells have wrong cell size, but data could be just fixed
    if (!allowLose) throw new Error();
    for (let i = 0; i < CellStructureBuilder.moduleDefs.length; i++) {
      const moduleCells = this.flatModuleCells(CellStructureBuilder.moduleDefs[i]);
      if (this.cellsContainModule(blockCells, CellStructureBuilder.moduleDefs[i], false)) {
        const moduleConnectors = moduleCells.map(eachCell => eachCell.connector);
        const ret = blockCells.filter(eachCell => moduleConnectors.indexOf(eachCell.connector) !== -1);
        // console.log('moduleCellsXXX', moduleDef, moduleConnectors, ret);
        return ret;
      }
      // else console.log("not contains: ", this.moduleDefs[i].type);
    }

    throw new Error();
  }

  private makeModuleFromCells(moduleCells: ICell[]): IModule {
    const moduleDef = this.findModuleDefByExactCells(moduleCells);
    let ret: IModule = {
      type: moduleDef.type,
      block: moduleCells[0].block,
      direction: moduleCells[0].direction,
      hasScreen: moduleDef.hasScreen,
      blocked_column: !!moduleCells[0].blocked_column,
      column_order: moduleCells[0].column_order || 0,
      columns: [],
    };
    moduleDef.columns.forEach((eachColumn, eachColumnIndex) => {
      let columnCells: ICell[] = [];
      eachColumn.forEach(eachCell => {
        const moduleCell = moduleCells.find(eachModuleCell => eachModuleCell.connector === eachCell.connector);
        if (!moduleCell) {
          throw new Error();
        }
        columnCells.push(moduleCell);
      });
      ret.columns.push(columnCells);
    });
    return ret;
  }

  private findModuleDefByExactCells(moduleCells: ICell[]): IAbstractModule {
    // first try an exact match with same compartment sizes, then just try to match by connectors
    // same logic as when we picked these cells
    for (let i = 0; i < CellStructureBuilder.moduleDefs.length; i++) {
      if (this.cellsContainModule(moduleCells, CellStructureBuilder.moduleDefs[i], true)) {
        return CellStructureBuilder.moduleDefs[i];
      }
    }
    for (let i = 0; i < CellStructureBuilder.moduleDefs.length; i++) {
      if (this.cellsContainModule(moduleCells, CellStructureBuilder.moduleDefs[i], false)) {
        return CellStructureBuilder.moduleDefs[i];
      }
    }
    throw new Error();
  }

  private cellsContainModule(blockCells: ICell[], moduleDef: IAbstractModule, strict: boolean): boolean {
    let moduleCells = this.flatModuleCells(moduleDef);
    let containedModuleCellsCnt = 0;
    const filter = strict
      ? (eachCell: ICell, eachModuleCell: IAbstractCell) => eachCell.connector === eachModuleCell.connector &&
        eachCell.cell_size_id === eachModuleCell.cell_size_id
      : (eachCell: ICell, eachModuleCell: IAbstractCell) => eachCell.connector === eachModuleCell.connector;
    moduleCells.forEach(eachModuleCell => {
      // if there is a same size and connector cell in blockCells then it's contained
      if (blockCells.filter(eachCell => filter(eachCell, eachModuleCell)).length === 1) {
        containedModuleCellsCnt++;
      }
    });
    return moduleCells.length === containedModuleCellsCnt;
  }

  private flatModuleCells(moduleDef: IAbstractModule): IAbstractCell[] {
    let ret: IAbstractCell[] = [];
    moduleDef.columns.forEach((eachColumn: IAbstractCell[]) => {
      eachColumn.forEach((eachCell) => ret.push(eachCell));
    });
    return ret;
  }

  private orderModules(modules: IModule[]) {
    return modules.sort((a: IModule, b: IModule): (0 | 1 | -1) => {
      if (a.block !== b.block) {
        return a.block < b.block ? -1 : 1;
      }
      if (a.type === IModuleType.master) {
        if (a.block === 0) {
          return 1;
        }
        return -1;
      } else if (b.type === IModuleType.master) {
        if (b.block === 0) {
          return 1;
        }
        return -1;
      }
      return 0;
    });
  }

}
